(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brightcode-magic-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Magic Carousel only — layout + viewport video gate.
   * Does not patch assets/slideshow.js (update-safe; other carousels untouched).
   */
  const MAGIC_MOBILE_MQ = '(max-width: 749px)';

  function magicIsMobile() {
    return window.matchMedia(MAGIC_MOBILE_MQ).matches;
  }

  function magicReduceMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function magicGetCards(scroller) {
    return scroller ? [...scroller.querySelectorAll(':scope > .card')] : [];
  }

  function magicScrollPaddingStart(scroller) {
    const raw = getComputedStyle(scroller).scrollPaddingInlineStart || '0';
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }

  function magicGoToSlide(section, indexOverride) {
    const slideshow = section.querySelector('slideshow-component');
    const scroller = slideshow?.querySelector('slideshow-slides');
    if (!slideshow || !scroller) return;

    const cards = magicGetCards(scroller);
    if (!cards.length) return;

    const mobile = magicIsMobile();
    let index =
      indexOverride != null
        ? Number(indexOverride)
        : mobile
          ? 0
          : Number(section.dataset.magicInitialSlide || 1);

    if (Number.isNaN(index) || index < 0) index = mobile ? 0 : 1;
    if (index > cards.length - 1) index = cards.length - 1;

    const card = cards[index];
    const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    let target;

    if (mobile) {
      // 2A — flush left to page gutter (prefer padding-inline-start over scroll-padding %)
      const pad =
        parseFloat(getComputedStyle(scroller).paddingInlineStart) || magicScrollPaddingStart(scroller) || 0;
      target = Math.max(0, card.offsetLeft - pad);
    } else {
      // Desktop centered peek
      target = card.offsetLeft - (scroller.clientWidth - card.offsetWidth) / 2;
    }

    scroller.scrollTo({ left: Math.min(Math.max(0, target), maxScroll), behavior: 'instant' });

    try {
      slideshow.current = index;
    } catch (e) {
      /* ignore */
    }

    cards.forEach((el, i) => {
      el.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    if (typeof section._magicSyncVideos === 'function') {
      section._magicSyncVideos();
    }
  }

  /**
   * 1A — only the active card video plays while the carousel section is in view.
   * Pause saves currentTime; play restores it (resume). Peeks stay paused.
   */
  function magicBindVideos(section) {
    if (section.dataset.magicVideoBound === '1') return;
    section.dataset.magicVideoBound = '1';

    let sectionInView = false;
    let scrollTimer;

    const videos = () => [...section.querySelectorAll('.card video')];

    function getActiveCard() {
      const slideshow = section.querySelector('slideshow-component');
      const scroller = slideshow?.querySelector('slideshow-slides');
      const cards = magicGetCards(scroller);
      if (!cards.length || !scroller) return null;

      // Prefer geometric active card from scroll (keeps peeks paused mid-swipe)
      const mobile = magicIsMobile();
      const pad = magicScrollPaddingStart(scroller);
      const ref = mobile
        ? scroller.scrollLeft + pad
        : scroller.scrollLeft + scroller.clientWidth / 2;

      let best = cards[0];
      let bestDist = Infinity;
      cards.forEach((card) => {
        const point = mobile ? card.offsetLeft : card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(point - ref);
        if (dist < bestDist) {
          bestDist = dist;
          best = card;
        }
      });

      return best;
    }

    function saveTime(video) {
      if (!video || Number.isNaN(video.currentTime)) return;
      video.dataset.magicTime = String(video.currentTime);
    }

    function restoreTime(video) {
      const t = parseFloat(video.dataset.magicTime || '');
      if (Number.isNaN(t)) return;
      try {
        if (Math.abs(video.currentTime - t) > 0.2) video.currentTime = t;
      } catch (e) {
        /* ignore seek errors before metadata */
      }
    }

    function disarmAutoplay(video) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.muted = true;
      video.playsInline = true;
    }

    function preferredSrc(video) {
      return (
        video.dataset.currentSrc ||
        (window.matchMedia('(max-width: 749px)').matches
          ? video.dataset.mobileSrc || video.dataset.desktopSrc
          : video.dataset.desktopSrc || video.dataset.mobileSrc) ||
        ''
      );
    }

    function ensureSrc(video) {
      const next = preferredSrc(video);
      if (!next) return;
      if (video.dataset.appliedSrc === next && (video.getAttribute('src') || video.currentSrc)) return;
      video.dataset.appliedSrc = next;
      video.dataset.currentSrc = next;
      video.preload = 'metadata';
      video.src = next;
      video.load();
    }

    function unloadSrc(video) {
      if (!video.getAttribute('src') && !video.currentSrc) return;
      saveTime(video);
      video.removeAttribute('src');
      video.removeAttribute('data-applied-src');
      delete video.dataset.appliedSrc;
      try {
        video.load();
      } catch (e) {
        /* ignore */
      }
    }

    function syncVideos() {
      const activeCard = getActiveCard();
      const allowPlay = sectionInView && !magicReduceMotion();

      videos().forEach((video) => {
        disarmAutoplay(video);
        const isActive = !!(activeCard && activeCard.contains(video));

        if (allowPlay && isActive) {
          ensureSrc(video);
          // Only seek/resume when starting playback — never reset a playing active video
          if (video.paused) {
            restoreTime(video);
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          }
        } else {
          if (!video.paused) saveTime(video);
          if (!video.paused) video.pause();
          // Drop peek/offscreen sources so 4G does not buffer every card MP4
          unloadSrc(video);
        }
      });
    }

    section._magicSyncVideos = syncVideos;

    videos().forEach((video) => {
      disarmAutoplay(video);
      if (!video.paused) {
        saveTime(video);
        video.pause();
      }
    });

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        sectionInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0);
        syncVideos();
      },
      { threshold: [0, 0.15, 0.35, 0.6] }
    );
    sectionObserver.observe(section);

    const scroller = section.querySelector('slideshow-slides');
    scroller?.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncVideos, 60);
      },
      { passive: true }
    );

    // Catch native autoplay / card-src swaps that call play() on peek cards
    section.addEventListener(
      'play',
      (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement) || !section.contains(video)) return;
        const activeCard = getActiveCard();
        if (!sectionInView || magicReduceMotion() || !activeCard?.contains(video)) {
          saveTime(video);
          video.pause();
        }
      },
      true
    );

    // After card responsive src swaps settle
    setTimeout(syncVideos, 200);
    setTimeout(syncVideos, 600);
  }

  function initMagicCarousels() {
    document.querySelectorAll('[data-magic-carousel]').forEach((section) => {
      if (section.dataset.magicBound === '1') return;
      section.dataset.magicBound = '1';

      magicBindVideos(section);

      const runInitial = () => {
        // Mobile must always open on slide 0 flush-left; desktop uses setting / center peek
        magicGoToSlide(section, magicIsMobile() ? 0 : undefined);
      };

      requestAnimationFrame(() => requestAnimationFrame(runInitial));
      setTimeout(runInitial, 50);
      setTimeout(runInitial, 150);
      setTimeout(runInitial, 400);
      setTimeout(runInitial, 900);

      // slideshow.js may select(initial) on a later frame — re-pin mobile start briefly
      let guardUntil = Date.now() + 1600;
      const guard = setInterval(() => {
        if (Date.now() > guardUntil) {
          clearInterval(guard);
          return;
        }
        if (!magicIsMobile()) return;
        const slideshow = section.querySelector('slideshow-component');
        const scroller = slideshow?.querySelector('slideshow-slides');
        const first = magicGetCards(scroller)[0];
        if (!slideshow || !scroller || !first) return;
        const pad = parseFloat(getComputedStyle(scroller).paddingInlineStart) || 0;
        const leftGap = first.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
        if (slideshow.current !== 0 || Math.abs(leftGap - pad) > 12) {
          magicGoToSlide(section, 0);
        }
      }, 120);

      let resizeTimer;
      let wasMobile = magicIsMobile();
      window.addEventListener(
        'resize',
        () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            const nowMobile = magicIsMobile();
            const slideshow = section.querySelector('slideshow-component');
            // Crossing breakpoint: mobile always restarts at slide 0; desktop keeps current/setting
            if (nowMobile !== wasMobile) {
              wasMobile = nowMobile;
              magicGoToSlide(section, nowMobile ? 0 : undefined);
              return;
            }
            const current = slideshow ? slideshow.current : null;
            magicGoToSlide(section, current != null ? current : undefined);
          }, 100);
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagicCarousels, { once: true });
  } else {
    initMagicCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target?.closest?.('.shopify-section')?.querySelector?.('[data-magic-carousel]') ||
      event.target?.querySelector?.('[data-magic-carousel]') ||
      (event.target?.hasAttribute?.('data-magic-carousel') ? event.target : null);
    if (!section) return;
    section.dataset.magicBound = '0';
    section.dataset.magicVideoBound = '0';
    initMagicCarousels();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brightcode-parallax"] && !Shopify.designMode) return;
  try {
    
  /**
   * Brightcode Parallax — sticky stack polish + light media preload.
   * Cards pin via CSS sticky; JS scales/dims a card as the next one covers it.
   * Fabric desktop (≥990px) scrolls `.page-wrapper`, not window.
   */
  (function () {
    const MOBILE_MQ = '(max-width: 749px)';
    const REDUCE_MQ = '(prefers-reduced-motion: reduce)';
    const SQUEEZE_MQ = '(min-width: 990px)';
    const PAGE_WRAPPER = '.page-wrapper';

    function prefersReducedMotion() {
      return window.matchMedia(REDUCE_MQ).matches;
    }

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function isSqueezeLayout() {
      return window.matchMedia(SQUEEZE_MQ).matches;
    }

    function getScrollEventTarget() {
      if (isSqueezeLayout()) {
        return document.querySelector(PAGE_WRAPPER) || document;
      }
      return document;
    }

    function stackEffectsEnabled(section) {
      if (prefersReducedMotion()) return false;
      if (isMobile() && section.dataset.stackMobile !== 'true') return false;
      return true;
    }

    function resetCards(cards) {
      cards.forEach((card) => {
        card.style.transform = '';
        card.style.filter = '';
      });
    }

    function updateStack(cards, scalePct) {
      const maxShrink = Math.max(0, Math.min(20, scalePct)) / 100;

      cards.forEach((card, index) => {
        const next = cards[index + 1];
        if (!next) {
          card.style.transform = '';
          card.style.filter = '';
          return;
        }

        const stickyTop = parseFloat(getComputedStyle(card).top) || 0;
        const cardH = card.getBoundingClientRect().height || 1;
        const nextTop = next.getBoundingClientRect().top;
        // 0 = next still below; 1 = next fully covering (at sticky top)
        const progress = Math.min(1, Math.max(0, 1 - (nextTop - stickyTop) / cardH));
        const scale = 1 - progress * maxShrink;
        card.style.transform = 'scale(' + scale.toFixed(4) + ')';
        // Dim only on desktop — filter paint is costlier on mobile
        if (isMobile()) {
          card.style.filter = '';
        } else {
          const brightness = 1 - progress * 0.28;
          card.style.filter = 'brightness(' + brightness.toFixed(3) + ')';
        }
      });
    }

    function lqipFromUrl(url) {
      if (!url) return '';
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('width', '48');
        return u.href;
      } catch (e) {
        return '';
      }
    }

    function paintLqip(card) {
      const surface =
        card.querySelector('.background-image-container, .video-background, video-background-component, .card__media-wrapper');
      if (!surface || surface.dataset.bcLqip === '1') return;
      const img = card.querySelector('.card__media-wrapper img');
      const src = img && (img.currentSrc || img.src);
      const lqip = lqipFromUrl(src);
      surface.style.backgroundColor = '#111';
      if (lqip) {
        surface.style.backgroundImage = 'url("' + lqip + '")';
        surface.style.backgroundSize = 'cover';
        surface.style.backgroundPosition = 'center';
      }
      surface.dataset.bcLqip = '1';
    }

    function preloadCard(card) {
      if (!card || card.dataset.bcMediaPreloaded === '1') return;
      card.dataset.bcMediaPreloaded = '1';
      paintLqip(card);
      card.querySelectorAll('.card__media-wrapper img').forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager';
        const src = img.currentSrc || img.src;
        if (!src) return;
        const pre = new Image();
        pre.decoding = 'async';
        pre.src = src;
      });
    }

    function bindMedia(section, cards) {
      if (section.dataset.parallaxMediaBound === '1') return;
      section.dataset.parallaxMediaBound = '1';

      // First two cards: LQIP + preload so sticky cover never flashes empty
      cards.slice(0, 2).forEach(preloadCard);
      cards.forEach(paintLqip);

      if (!('IntersectionObserver' in window)) {
        cards.forEach(preloadCard);
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            preloadCard(card);
            const idx = cards.indexOf(card);
            if (idx >= 0 && cards[idx + 1]) preloadCard(cards[idx + 1]);
          });
        },
        { root: null, rootMargin: '100% 0px 100% 0px', threshold: 0.01 }
      );
      cards.forEach((card) => io.observe(card));
    }

    function bindSection(section) {
      if (section.dataset.parallaxBound === '1') return;
      section.dataset.parallaxBound = '1';

      const cards = [...section.querySelectorAll('.brightcode-parallax__cards .card')];
      if (!cards.length) return;

      bindMedia(section, cards);

      let ticking = false;
      let scrollTarget = null;

      function requestTick() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          if (!stackEffectsEnabled(section)) {
            resetCards(cards);
            return;
          }
          const scalePct = Number(section.dataset.stackScale || 8);
          updateStack(cards, scalePct);
        });
      }

      function attachScroll() {
        if (scrollTarget) {
          scrollTarget.removeEventListener('scroll', requestTick);
        }
        scrollTarget = getScrollEventTarget();
        scrollTarget.addEventListener('scroll', requestTick, { passive: true });
      }

      attachScroll();
      window.addEventListener('resize', requestTick, { passive: true });

      const squeezeMq = window.matchMedia(SQUEEZE_MQ);
      const onSqueezeChange = () => {
        attachScroll();
        requestTick();
      };
      if (typeof squeezeMq.addEventListener === 'function') {
        squeezeMq.addEventListener('change', onSqueezeChange);
      } else if (typeof squeezeMq.addListener === 'function') {
        squeezeMq.addListener(onSqueezeChange);
      }

      requestTick();
    }

    function initAll() {
      document.querySelectorAll('[data-brightcode-parallax]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target;
      const section =
        root?.querySelector?.('[data-brightcode-parallax]') ||
        (root?.hasAttribute?.('data-brightcode-parallax') ? root : null);
      if (!section) return;
      section.dataset.parallaxBound = '0';
      section.dataset.parallaxMediaBound = '0';
      bindSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
